import {useMutation, useQuery} from 'admin/lib/apollo'
import clearCache from './clearCache'
import {GET_BANK_IMPORT, IMPORT_PAYMENTS} from '../gql/BankImport.gql'
import {DirectUpload} from '@rails/activestorage'
import useStateObject from './useStateObject'
import {useState} from 'react'
import useDestroyable from './useDestroyable'

export default bankImportId => {
  const {data: {bankImport = {}} = {}, error: getError} = useQuery(GET_BANK_IMPORT, {
    variables: {bankImportId},
    skip: !bankImportId
  })

  const [importPayments, {data, error: importError}] = useMutation(IMPORT_PAYMENTS, {
    flash: 'Importing payments...'
  })

  const [uploadError, setUploadError, resetUploadError] = useStateObject({})
  const [signedBlobId, setSignedBlobId] = useState()
  const uploadAndImport = ({file, ...data}, onComplete) => {
    resetUploadError()

    if (data.id || data.signedBlobId) {
      importPayments(data, onComplete)
      return
    }

    if (!file) {
      setUploadError({file: ['no file selected']})
      return
    }

    const upload = new DirectUpload(file, '/rails/active_storage/direct_uploads')
    upload.create((error, blob) => {
      if (error) {
        setUploadError({file: ['upload failed']})
      } else {
        setSignedBlobId(blob.signed_id)
        importPayments({...data, signedBlobId: blob.signed_id}, onComplete)
      }
    })
  }

  const {destroy, errors: destroyError} = useDestroyable('BankImport', bankImportId)

  return {
    bankImport: {
      ...bankImport,
      ...(data?.bankImport || {}),
      signedBlobId
    },
    destroy,
    errors: getError || uploadError || importError || destroyError || {},
    create: uploadAndImport
  }
}
